<template>
  <div
    style="
      position: absolute;
      width: 880px;
      height: 200px;
      right: 10px;
      top: 747px;
    "
  >
    <dv-border-box-7 style="height: 200px">
      <div style="padding: 5px">
        <div style="float: left; width: 40%">
          <!-- 子组件：过去一段时间的天气记录 -->
          <chart-past />
        </div>
        <div
          style="
            height: 180px;
            float: left;
            width: 16%;
            margin-left: 15px;
            border-left: solid 1px #808080;
            border-right: solid 1px #808080;
            text-align: center;
          "
        >
          <div style="color: #cfcfcf; font-size: 13px; margin-bottom: 10px">
            实时天气
          </div>
          <!-- 天气情况 -->
          <p style="color: #b39f63; font-size: 16px">
            <!-- {{ weather.weather }} -->
            晴
          </p>
          <!-- 实时气温 -->
          <p>
            <span style="color: #99afcf; font-size: 24px">
              <!-- {{ temp }} -->
              18
            </span>
            <span style="color: #999; font-size: 11px">℃</span>
          </p>
          <!-- 气温预测 -->
          <p style="color: #999; font-size: 12px">{{ weather.temperature }}</p>
          <!-- 风力 -->
          <p style="color: #999; font-size: 12px">
            <!-- {{ weather.wind }} {{ weather.winp }} -->
            南风1级
          </p>
        </div>
        <div style="float: right; width: 40%">
          <!-- 子组件：未来一段时间天气预测 -->
          <chart-coming />
        </div>
        <div style="clear: both"></div>
      </div>
    </dv-border-box-7>
  </div>
</template>
<script>
import axios from 'axios'
import ChartPast from './chart-past.vue'
import ChartComing from './chart-coming.vue'
export default {
  components: { ChartPast, ChartComing },
  data() {
    return {
      weather: {},
    }
  },
  mounted() {
    setTimeout(() => {
      axios
        .get('http://berry-internet.zkhfzhnyg.cn/api/weather/real')
        .then((resp) => {
          console.log('weather', resp.data)
          this.weather = resp.data
        })
    })
  },
  computed: {
    temp() {
      console.log('this.weather.tempCurr=', typeof this.weather.tempCurr)
      return this.weather.tempCurr ? this.weather.tempCurr.slice(0, -1) : ''
    },
  },
}
</script>


// WEBPACK FOOTER //
// src/components/screen28896/weather-zone/index.vue